// 3rd party libs
import React from 'react';
import styled from 'styled-components';
import theme from 'themes';

// Components
import { Typography } from 'components';
import X from 'icons/indexed-icons/X';
import ChevronLeft from 'icons/indexed-icons/ChevronLeft';

interface Props {
  heading?: string | JSX.Element;
  subheading?: string | JSX.Element;
  onClose?: (() => void) | null;
  onBack?: (() => void) | null;
  afterComponent?: React.ReactNode;
  bgColor?: string;
  marginLeft?: string;
}

const Header = styled.div<{ bgColor?: string; marginLeft?: string }>`
  padding: 16px 20px 24px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  background-color: ${({ bgColor: bg }) => bg ?? ''};
  .flyout-header__text {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
  }
  .flyout-sub-header {
  }
`;

const SubHeader = styled.div`
  margin: 0px 20px 4px 20px;
  font-size: 14px;
  padding-bottom: 4px;
  border-bottom: 1px solid #c8c8c8;
  font-color: #323130;
`;

const IconButton = styled.button`
  background: inherit;
  font-size: inherit;
  border: none;
  cursor: pointer;
  svg path {
    stroke-width: 2;
  }
`;

const BackButton = styled(IconButton)`
  margin-right: 0.5rem;
  padding-left: 0;
`;

const CloseButton = styled(IconButton)`
  margin-left: auto;
`;

const FlyoutHeader = ({
  onClose,
  onBack,
  heading,
  subheading,
  afterComponent,
  bgColor,
  marginLeft
}: Props): JSX.Element => {
  return (
    <>
      <Header className="flyout-header" bgColor={bgColor} marginLeft={marginLeft}>
        <Typography className="flyout-header__text">
          {onBack && (
            <BackButton onClick={() => onBack()}>
              <ChevronLeft color={theme.colors.darkGrey} />
            </BackButton>
          )}
          {heading}
        </Typography>
        {afterComponent && afterComponent}
        {onClose && (
          <CloseButton onClick={() => onClose()}>
            <X color={theme.colors.darkGrey} />
          </CloseButton>
        )}
      </Header>
      {subheading && <SubHeader>{subheading}</SubHeader>}
    </>
  );
};

export default FlyoutHeader;
